<template>
  <v-row class="supplier-detail custom-border-to">
    <v-col md="12" sm="12" class="pt-0 px-0">
      <v-skeleton-loader
        class="custom-skeleton"
        v-if="pageLoading"
        type="table-tbody"
      >
      </v-skeleton-loader>
      <v-simple-table v-else class="simple-table">
        <template v-slot:default>
          <thead>
            <tr style="background-color: #f3f6f9; color: #24326d">
              <td style="width: 60px !important">
                <v-checkbox
                  v-model="selectedAll"
                  class="hide-margin"
                  color="cyan"
                  dense
                  hide-details
                ></v-checkbox>
              </td>
              <td
                style="width: 60px !important"
                class="font-size-13 text-uppercase font-weight-500"
              >
                Status
                <!-- Active / In-Active -->
              </td>
              <td class="font-size-13 text-uppercase font-weight-500">Name</td>
              <td
                class="font-size-13 text-uppercase font-weight-500 text-nowrap"
              >
                Display Name
              </td>
              <td
                class="font-size-13 text-uppercase font-weight-500 text-nowrap"
              >
                Email
              </td>
              <td
                class="font-size-13 text-uppercase font-weight-500 text-nowrap"
              >
                Phone Number
              </td>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(person, index) in rowData"
              :key="index"
              :class="{
                'custom-border-top': index == 0,
                'orange_lighten-5': index % 2 == 0,
              }"
            >
              <td style="width: 60px !important">
                <v-checkbox
                  v-model="selectedRows"
                  class="hide-margin"
                  color="cyan"
                  dense
                  hide-details
                  v-bind:value="person.id"
                ></v-checkbox>
              </td>
              <td
                link
                v-on:click="selectCustomer(person.id)"
                class="font-size-14 font-weight-500"
              >
                <div
                  style="width: 60px !important"
                  v-on:click.prevent.stop="activeInactive(person)"
                >
                  <v-switch
                    :disabled="person.default == 1 || supplier.activated == 0"
                    v-model="person.activated"
                    class="mt-0"
                    inset
                    v-on:click.prevent.stop="activeInactive(person)"
                    color="green"
                  ></v-switch>
                </div>
              </td>
              <td
                link
                v-on:click="selectSupplier(person.id)"
                class="font-size-14 font-weight-500 text-capitalize"
              >
                {{ person.title }}. {{ person.first_name }}
                <template v-if="person && person.last_name">
                  {{ person.last_name }}
                </template>
                <div>
                  <v-chip
                    small
                    color="blue white--text"
                    label
                    class=""
                    v-if="person.default == 1"
                  >
                    <span class="font-size-16 font-weight-500"> Primary </span>
                  </v-chip>
                </div>
              </td>
              <!--  <td
                link
                v-on:click="selectSupplier(person.id)"
                class="font-size-14 font-weight-500 text-capitalize"
              >
                {{ person.title }}.
              </td>
              <td
                link
                v-on:click="selectSupplier(person.id)"
                class="font-size-14 font-weight-500"
              >
                <template v-if="person && person.first_name">
                  {{ person.first_name }}
                </template>
                <em v-else class="text-muted"> no First name</em>
              </td>
              <td
                link
                v-on:click="selectSupplier(person.id)"
                class="font-size-14 font-weight-500"
              >
                <template v-if="person && person.last_name">
                  {{ person.last_name }}
                </template>
                <em v-else class="text-muted"> no last name</em>
              </td> -->
              <td
                link
                v-on:click="selectSupplier(person.id)"
                class="font-size-14 font-weight-500"
              >
                <template v-if="person && person.display_name">
                  {{ person.display_name }}
                </template>
                <em v-else class="text-muted"> no display name</em>
              </td>
              <td
                link
                v-on:click="selectSupplier(person.id)"
                class="font-size-14 font-weight-500 text-lowercase"
              >
                <template v-if="person && person.primary_email">
                  {{ person.primary_email }}
                </template>
                <em v-else class="text-muted"> no email adddress</em>
              </td>
              <td
                link
                v-on:click="selectSupplier(person.id)"
                class="font-size-14 font-weight-500"
              >
                <template v-if="person && person.primary_phone">
                  {{ person.primary_phone }}
                </template>
                <em v-else class="text-muted"> no phone number</em>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-col>
  </v-row>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import { PATCH } from "@/core/services/store/request.module";
import { ErrorEventBus } from "@/core/lib/message.lib";

export default {
  name: "contact-persons",
  title: "Supplier",
  mixins: [CommonMixin],
  props: {
    supplier: {
      type: Object,
      required: true,
      default: function () {
        return {};
      },
    },
    pageLoading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      rowData: [],
      selectedRows: [],
    };
  },
  components: {},
  watch: {
    selectedRows(param) {
      this.$emit("selectedRows", param);
    },
    supplier: {
      deep: true,
      immediate: true,
      handler() {
        this.assignData();
      },
    },
  },
  methods: {
    activeInactive(data) {
      if (_this.supplier.activated == 0) {
        return false;
      }
      if (data.default == 1) {
        ErrorEventBus.$emit(
          "update:error",
          "The Primary Contact Person can’t be In-Active."
        );
        return false;
      }

      const _this = this;
      if (data.activated == false) {
        data.activated = 0;
      } else {
        data.activated = 1;
      }
      _this.$store
        .dispatch(PATCH, {
          url: `single-supplier/${data.activated}/${data.id}`,
          data: {
            id: data.id,
            status: data.activated,
          },
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {});
    },
    selectSupplier(param) {
      this.$emit("selectSupplier", param);
    },
    assignData() {
      const _this = this;
      if (_this.lodash.isEmpty(_this.supplier.persons) === false) {
        _this.rowData = _this.supplier.persons;
      }
    },
  },
  mounted() {
    const _this = this;
    _this.assignData();
    _this.$root.$on("clearSelection", () => {
      _this.selectedRows = [];
    });
  },
  beforeDestroy() {
    /*this.$root.$off("clearSelection");*/
  },
  computed: {
    selectedAll: {
      set(param) {
        this.selectedRows = [];
        if (param && this.rowData.length) {
          for (let i = this.rowData.length - 1; i >= 0; i--) {
            this.selectedRows.push(this.rowData[i].id);
          }
        }
      },
      get() {
        let totalItems = this.rowData.length;
        return totalItems > 0 ? this.selectedRows.length === totalItems : false;
      },
    },
  },
};
</script>
